<div>
    <h2 mat-dialog-title>{{actionDialogTitle}}</h2>
    <form novalidate [formGroup]="actionForm">
        <div mat-dialog-content>
            <!-- Action Type -->
            <mat-form-field class="w-100">
                <mat-label>Action Type</mat-label>
                <mat-select id="actionTypeSelect" formControlName="actionTypeId" (selectionChange)="getActions($event)">
                    <mat-option *ngFor="let actionType of actionTypes" [value]="actionType.id">
                        {{actionType.name}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="actionForm.get('actionTypeId').hasError('required')">required</mat-error>
            </mat-form-field>

            <!-- Action -->
            <mat-form-field class="w-100">
                <mat-label>Action</mat-label>
                <mat-select id="actionSelect" formControlName="actionsId" (selectionChange)="onActionParamChange($event)">
                    <mat-option *ngFor="let act of filteredActions" [value]="act.id">
                        {{act.name}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="actionForm.get('actionsId').hasError('required')">required</mat-error>
            </mat-form-field>

            <!-- Action Name -->
            <mat-form-field *ngIf="!disableNamedActions && accountSettingsLoaded" id="actionNameFormField" class="w-100">
                <mat-label id="actionNameLabel">Name</mat-label>
                <input matInput id="actionName" formControlName="actionName">
                <mat-error *ngIf="actionForm.get('actionName').hasError('required')">required</mat-error>
            </mat-form-field>

            <!-- Rules -->
            <auto-suggest [list]="rules" placeholder="Rule" field="name" dataKey="id" formControlName="rulesId" [showRequiredError]="actionForm.get('rulesId').hasError('required')"></auto-suggest>

            <!-- Billing Event -->
            <mat-form-field class="w-100">
                <mat-label>Billing Event</mat-label>
                <mat-select formControlName="billingEventID" id="billingEventSelect">
                    <mat-option value="">Select</mat-option>
                    <mat-option *ngFor="let billingEvent of billingEvents" [value]="billingEvent.billingEventID">
                        {{billingEvent.billingEventName}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="actionForm.get('billingEventID').hasError('required')">required</mat-error>
            </mat-form-field>

            <!-- Integration Fields -->
            <div *ngIf="isIntegrationV2Action">
                <map-keys-dropdown *ngIf="!autoGeneratedMapkeyIntegration" [displayList]="responseMapKeys" placeholder="Response" formControlName="response"
                    [formControl]="actionForm?.get('response')" showArrow="true" [allowedTypes]="[mapKeyTypeEnum.Integration]">
                </map-keys-dropdown>
                <mat-form-field *ngIf="autoGeneratedMapkeyIntegration" class="w-100" style="padding-bottom: 1rem">
                    <mat-label>Response</mat-label>
                    <input type="text" matInput [readonly]="true" [disabled]="true" [value]="autoGenIntegrationResponse" matTooltip="Integration Mapkey is auto-generated upon save"/>
                    <mat-hint>Auto-generated upon save</mat-hint>
                </mat-form-field>
                
                <div class="row">
                    <div class="col-md-12 action-integration-header">Inputs</div>
                </div>
                @if (isInputDictionarySetup) {
                    <div class="row">
                        <div class="col-md-12 action-integration-message">Inputs for this integration are managed outside this screen. Please contact your administrator for setup help.</div>
                    </div>
                }

                <div formArrayName="inputParams"  style="padding-bottom: 1rem">
                    <div class="row" *ngFor="let inputParam of inputParameters; let inputIndex = index; let odd = odd;"
                        [formGroupName]="inputIndex">
                        <div class="col-md-5" style="display: flex; align-items: center">
                            <input type="hidden" formControlName='metadata_Id' value="inputParam.metadata_Id">
                            <span *ngIf="!inputParam.displayName">{{inputParam.metadata_Value}} <span
                                *ngIf="inputParam.isRequired">*</span></span>
                            <span *ngIf="inputParam.displayName">{{inputParam.displayName}} <span
                                *ngIf="inputParam.isRequired">*</span></span>
                        </div>
                        <div class="col-md-7 action-mapkey-dropdown">
                            <map-keys-dropdown [displayList]="inputParameterMapKeys" placeholder="Mapkey"
                                [showRequiredError]="actionForm?.get('inputParams')?.get(inputIndex + '')?.get('mapKey_Id')?.hasError('required') && _formSubmitted"
                                formControlName="mapKey_Id"
                                [formControl]="actionForm?.get('inputParams')?.get(inputIndex + '')?.get('mapKey_Id')"
                                showArrow="true"></map-keys-dropdown>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 action-integration-header">Outputs</div>
                </div>
                <div *ngIf="!autoGeneratedMapkeyIntegration" formArrayName="outputParams" class="mb-5">
                    <div class="row" *ngFor="let actionOutput of actionOutputs; let outputIndex = index; let odd = odd;"
                        [formGroupName]="outputIndex">
                        <div class="col-md-5">
                            <mat-form-field class="w-100">
                                <mat-select formControlName="metadata_Id">
                                    <mat-option
                                        [matTooltip]="outputParam.metadata_Value"
                                        matTooltipPosition="right"
                                        *ngFor="let outputParam of outputParameters"
                                        [value]="outputParam.metadata_Id">
                                        {{outputParam.metadata_Value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 action-mapkey-dropdown">
                            <map-keys-dropdown [displayList]="outputParameterMapKeys"
                                placeholder="Mapkey"
                                [showRequiredError]="actionForm?.get('outputParams')?.get(outputIndex + '')?.get('mapKey_Id')?.hasError('required') && _formSubmitted"
                                formControlName="mapKey_Id"
                                [formControl]="actionForm?.get('outputParams')?.get(outputIndex + '')?.get('mapKey_Id')"
                                showArrow="true"></map-keys-dropdown>
                        </div>
                        <div class="col-md-1" style="display: flex; align-items: center; justify-content: center">
                            <mat-icon style="cursor: pointer" (click)="onRemoveOutputParameter(outputIndex)">delete</mat-icon>
                        </div>
                    </div>
                    <div class="row col-md-12" *ngIf="actionOutputs.length < outputParameters.length">
                        <button type="button" class="btn btn-link btn-sm float-end custom" (click)="addOutputParameter()"><i aria-hidden="true" class="fa fa-plus"></i> Add Output</button>
                    </div>
                </div>
                <div id="autoGenMessage" *ngIf="autoGeneratedMapkeyIntegration">
                    <div class="pb-3 pt-3">Output Mapkeys are auto-generated upon save.</div>
                    <div>Go to <span style="color: black; font-size: 16px;font-style: italic; font-weight: 700; line-height: 20px;">{{autoGenIntegrationMessage}}</span> on the Mapkeys page to view.</div>
                </div>
            </div>

            
            <ng-container *ngIf="!paramControlsLoaded">
                <mat-spinner mode="indeterminate" diameter="30"/>
            </ng-container>
            <div *ngIf="paramControlsLoaded">
                <ng-container dynamicActionFormControl *ngFor="let param of actionParams;" [config]="param" [group]="actionForm"></ng-container>
            </div>
        </div>
        <mat-dialog-actions align="end" class="me-1">
            <mrs-btn-tertiary buttonLabel="Cancel" buttonId="cancelBtn" (onClick)="cancelAction()"></mrs-btn-tertiary>
            <mrs-btn-primary buttonLabel="Save" buttonId="saveBtn" (onClick)="saveAction()" *ngIf="isEditView && checkACL('W')"></mrs-btn-primary>
        </mat-dialog-actions>
    </form>
</div>
